import React, { useState, useEffect, useRef } from "react";
import axios from "../../api/axios";
import { toast } from "react-toastify";
import FormDropDown from "../../components/forms/DropDownList/FormDropDown";
import "./ClawCameraFeed.scss";

function ClawCameraFeed() {
    const [currentFeed, setCurrentFeed] = useState('clawcam1.twitchcampaignstudio.com');
    const [currentFeedIndex, setCurrentFeedIndex] = useState(0);
    const [imgKey, setImgKey] = useState(Date.now()); // For forcing image refresh
    const containerRef = useRef(null);
    
    // Camera feed definitions
    const clawCameraFeeds = [
        {
            id: 'machine1cam1',
            label: 'Left, Cam 1',
            value: 'clawcam1.twitchcampaignstudio.com'
        },
        {
            id: 'machine1cam2',
            label: 'Left, Cam 2',
            value: 'clawcam2.twitchcampaignstudio.com'
        },
        {
            id: 'machine2cam1',
            label: 'Right, Cam 1',
            value: 'clawcam3.twitchcampaignstudio.com'
        },
        {
            id: 'machine2cam2',
            label: 'Right, Cam 2',
            value: 'clawcam4.twitchcampaignstudio.com'
        }
    ];
    
    // Add resize handler to adjust container size
    useEffect(() => {
        const handleResize = () => {
            if (containerRef.current) {
                // Set explicit max height to ensure it fits on screen
                const viewportHeight = window.innerHeight;
                const containerTop = containerRef.current.getBoundingClientRect().top;
                const maxHeight = viewportHeight - containerTop - 20; // 20px bottom padding
                containerRef.current.style.maxHeight = `${maxHeight}px`;
            }
        };
        
        // Run initially and on window resize
        handleResize();
        window.addEventListener('resize', handleResize);
        
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    });

    const switchFeed = (index) => {
        setCurrentFeed(clawCameraFeeds[index].value);
        setCurrentFeedIndex(index);
        setImgKey(Date.now()); // Force image refresh on feed change
    }

    // Construct the URL for the embed view
    const getEmbedUrl = () => {
        return `https://${currentFeed}/axis-cgi/mjpg/video.cgi`;
    }

    return (
        <div className="claw-camera-page">
            <h1 className="page-title">CLAW CAMERA FEED</h1>
            
            <div className="camera-control-section">
                <div className="camera-selector">
                    <FormDropDown
                        label='Select Camera Feed'
                        items={clawCameraFeeds}
                        value={currentFeed}
                        selectFunc={(e, id, item) => {switchFeed(item.index)}}
                        currentIndex={currentFeedIndex}
                    />
                </div>
            </div>
            
            <div className="camera-display-section" ref={containerRef}>
                <div className="camera-feed-container">
                    <div className="feed-wrapper">
                        <img 
                            key={imgKey}
                            src={getEmbedUrl()} 
                            alt={`Claw Camera Feed - ${clawCameraFeeds[currentFeedIndex].label}`}
                            className="camera-feed-image"
                            onError={(e) => {
                                console.error('Image failed to load:', e);
                                e.target.style.display = 'none';
                                setTimeout(() => {
                                    e.target.style.display = 'block';
                                    e.target.src = getEmbedUrl() + '?' + new Date().getTime();
                                }, 2000);
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ClawCameraFeed;
